'use strict';

module Patersons {

    export interface RecentResearchScope extends ng.IScope {
        events: RecentResearchCtrl;
        reverse: boolean;
        predicate: string;

        hasData: boolean;
        isLoading: boolean;

        items: any[];
        filteredItems: any[];

        itemsPerPage: number;
        currentPage: number;

        selectedCode: string;
        selectedDate: Date;
        selectedAnalysts: string;
        selectedRecommendation: string;
    }
    export abstract class RecentResearchCtrl extends ResearchBaseCtrl {
        scope: Patersons.RecentResearchScope;
        morningStarService: Patersons.MorningStarService;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'researchFeedService', 'navigationService', 'morningStarService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, researchFeedService, navigationService, morningStarService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope; 
            this.scope.events = this;
            this.scope.reverse = true;
            this.morningStarService = morningStarService;
            this.scope.hasData = false;
            
            this.scope.predicate = "dateWritten";
            this.scope.selectedCode = "";
            this.scope.selectedDate = new Date();
            this.scope.selectedAnalysts = "";
            this.scope.selectedRecommendation = "";
            this.scope.currentPage = 1;
            this.scope.itemsPerPage = 15;
            this.load();
        }
        load() {
            this.scope.isLoading = true;
            this.morningStarService.getRecentResearch(true).then((data) => {
                this.scope.$apply(() => {
                    this.scope.hasData = true;
                    this.scope.isLoading = false;
                    this.scope.items = data;
                    this.scope.filteredItems = data;

                });
            })
        }
        
        filterArray(array, filters) {
            const filterKeys = Object.keys(filters);
            return array.filter(item => {
              // validates all filter criteria
              return filterKeys.every(key => {
                // ignores non-function predicates
                if (typeof filters[key] !== 'function') return true;
                return filters[key](item[key]);
              });
            });
          }
        filterItems(){
            const filters = {} as any;
            if(this.scope.selectedCode){
                filters.asxcode = (selectedCode) => selectedCode === this.scope.selectedCode
            }
            if(this.scope.selectedAnalysts){
                filters.author = (author) => author === this.scope.selectedAnalysts
            }
            if(this.scope.selectedRecommendation){
                filters.licenseeRecommendation = (licenseeRecommendation) => licenseeRecommendation === this.scope.selectedRecommendation
            }
            if(this.scope.selectedDate){
                filters.dateWritten = (dateWritten) => new Date(dateWritten) <= this.scope.selectedDate
            }
            this.scope.filteredItems = this.filterArray(this.scope.items, filters)

        }
        onFilterChange(property, value){
            this.scope[property] = value;
            this.filterItems()
        }
        order(predicate) {
            this.scope.reverse = (this.scope.predicate === predicate) ? !this.scope.reverse : false;
            this.scope.predicate = predicate;
        }
    }
}
